export default __webpack_public_path__ + "static/media/number-of-total-register-today.a85f5b1d.svg";